// extracted by mini-css-extract-plugin
export var NavigationContainer = "Navigation-module--NavigationContainer--1s6K1";
export var Links = "Navigation-module--Links--3wVJf";
export var MenuItemLink = "Navigation-module--MenuItemLink--2nyXw";
export var ContactBtn = "Navigation-module--ContactBtn--CkAFD";
export var HamburgerMenu = "Navigation-module--HamburgerMenu--2HnZP";
export var MiniMenu = "Navigation-module--MiniMenu--3KDEa";
export var MenuItemWrapper = "Navigation-module--MenuItemWrapper--3kmOB";
export var ServicesSubMenu = "Navigation-module--ServicesSubMenu--1hl1c";
export var ComplianceSubMenu = "Navigation-module--ComplianceSubMenu--2QZkE";